import { externalLaunchContextAtom } from '@/atoms/externalLaunchAuthAtoms';
import { sessionListHost } from '@/composition/hosts/session/session-list/session-list-host';
import { useSessionListVersion } from '@/composition/hosts/session/session-list/useSessionListVersion';
import { useIsFhirAuth } from '@/hooks/integrations/useIsFhirAuth';
import {
  LazyConsolidatedSessionsBar as ConsolidatedSessionsBar,
  LazySessionsBar as SessionsBar,
  LazySessionsBarV2 as SessionsBarV2,
} from '@heidi/session';
import { useAtomValue } from 'jotai';

/**
 * Sessions panel content for mobile sidebar.
 * Conditionally renders ConsolidatedSessionsBar, SessionsBarV2, or legacy SessionsBar based on feature flags.
 * Hidden when launched from any EHR integration (Epic FHIR or generic EHR like Healthdirect).
 */
export const SessionsPanelContent = () => {
  const isFhirAuth = useIsFhirAuth();
  const isGenericEhrLaunch = Boolean(
    useAtomValue(externalLaunchContextAtom)?.ehrProvider
  );
  const isEhrLaunch = isFhirAuth || isGenericEhrLaunch;
  const sessionListVersion = useSessionListVersion();

  if (isEhrLaunch) {
    return null;
  }

  if (sessionListVersion === 'consolidated') {
    return <ConsolidatedSessionsBar host={sessionListHost} />;
  }
  if (sessionListVersion === 'v2') {
    return <SessionsBarV2 host={sessionListHost} />;
  }
  return <SessionsBar host={sessionListHost} />;
};
